import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  OverlayTrigger,
  Tooltip
} from 'react-bootstrap';
import Moment from 'moment';
import Datetime from 'react-datetime';
import { formatTimezoneDateTime } from 'helper/unit-helper';
import Avatar from 'components/avatar';
import { Breadcrumb } from 'components/breadcrumb/breadcrumb';
import Input from 'components/react-validation/components/input';
import Submit from '../../components/react-validation/components/submit';
import * as Vali from 'helper/validator-helper';
import Form from 'components/react-validation/components/form';
import PhoneNumberInput from 'components/PhoneNumberInput';
import * as LotActionType from '../constants';
import Translate from 'components/translate';
import { CheckBoxSingle } from '../../components/checkboxes/check-box-single';

class SetNewTenancy extends Component {
  static propTypes = {
    match: PropTypes.object,
    history: PropTypes.object,
    location: PropTypes.object,
    dispatch: PropTypes.func,
    lotProfile: PropTypes.object,
    LotProfile: PropTypes.object
  }

  constructor(props) {
    super(props);
    this.state = {
      moveInDate: null,
      email: '',
      emailCheckType: null,
      userData: null,
      disabledClassBtn: '',
      dateError: null,
    };
  }
  onBindingLot = () => {
    this.props.dispatch({
      type: LotActionType.GET_LOT_BY_ID_ASYNC,
      params: this.props.lotProfile.id,
      callback: () => {
        this.onCustomAction();
      }
    });
  }

  toolTip() {
    return (
      <Tooltip id='set-new-ownership-tooltip' className='in tooltip-siteone'>
        <span>If the email address does not appear to be your <Translate translateKey='homeowner' />, we will send an invitation to the <Translate translateKey='homeowner' /> to activate their account under your domain.</span>
      </Tooltip>
    );
  }

  onCustomAction = () => {
    const queryParams = new URLSearchParams(this.props.location.search);
    this.props.history.push(this.props.location.pathname + `?active=${queryParams.get('active')}`);
  }

  onValidateEmail = (value) => {
    let emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,8}$/;
    if (emailPattern.test(value.trim())) {
      return true;
    }
    return false;
  }

  onChangeEmail = (e) => {
    this.setState({
      email: e.target.value ? e.target.value.trim() : ''
    });
  }

  onClickToEditEmail = () => {
    // if (this.form) { this.form.resetForm(this.refs); }
    this.setState({
      emailCheckType: null,
      userData: null
    });
  }

  onCheckEmail = () => {
    const { email } = this.state;
    if (this.onValidateEmail(email)) {
      this.props.dispatch({
        type: LotActionType.CHECK_TENANCY_EXISTING_BY_EMAIL_ASYNC,
        params: {
          lotId: this.props.lotProfile.id,
          email
        },
        callback: (type, data) => { this.onCallbackCheckEmail(type, data); }
      });
    }
  }

  onEnter(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      if (this.onValidateEmail(this.state.email)) {
        this.onCheckEmail();
      }
    }
  }

  onCallbackCheckEmail = (type, data) => {
    this.setState({
      emailCheckType: type,
      userData: data
    });
  }

  onSubmit = (e) => {
    e.preventDefault();
    this.onSetNewLot();
  }

  onSetNewLot = () => {
    const { userData, moveInDate } = this.state;
    let purchaseDateValue = null;
    if (moveInDate !== '') {
      purchaseDateValue = moveInDate;
    }
    if (this.state.emailCheckType === 3) {
      const formData = this.form.getValues();
      this.props.dispatch({
        type: LotActionType.INVITE_TENANCY_ASYNC,
        params: {
          moveInDate: Moment.isMoment(purchaseDateValue) ? formatTimezoneDateTime(purchaseDateValue) : purchaseDateValue,
          lotId: this.props.lotProfile.id,
          firstName: formData.firstName,
          lastName: formData.lastName,
          phoneNumber: this.phoneNumber.state.value,
          daytimePhoneNumber: this.daytimePhoneNumber.state.value,
          email: userData.email
        },
        callback: () => {
          this.onBindingLot();
        }
      });
    }
    else if (this.state.emailCheckType === 1) { // (this.state.emailCheckType === 2 || this.state.emailCheckType === 1)
      const data = {
        tenancyId: userData.id,
        moveInDate: Moment.isMoment(purchaseDateValue) ? formatTimezoneDateTime(purchaseDateValue) : purchaseDateValue
      };

      this.props.dispatch({
        type: LotActionType.SET_TENANCY_TO_LOT_ASYNC,
        params: {
          lotId: this.props.lotProfile.id,
          data
        },
        callback: () => {
          this.onBindingLot();
        }
      });
    }
    else if (this.state.emailCheckType === 2) {
      this.props.dispatch({
        type: LotActionType.INVITE_TENANCY_ASYNC,
        params: {
          moveInDate: Moment.isMoment(purchaseDateValue) ? formatTimezoneDateTime(purchaseDateValue) : purchaseDateValue,
          lotId: this.props.lotProfile.id,
          firstName: userData.firstName,
          lastName: userData.lastName,
          phoneNumber: userData.phoneNumber,
          daytimePhoneNumber: userData.daytimePhoneNumber,
          email: userData.email
        },
        callback: () => {
          this.onBindingLot();
        }
      });
    }
  }

  onErrorPhoneNumber = (status) => {
    this.setState({
      errorPhoneNumber: status
    });
  }

  onErrorDaytimePhoneNumber = (status) => {
    this.setState({
      errorDaytimePhoneNumber: status
    });
  }

  render() {
    const breadcrumbs = [
      { title: 'Ownership info', url: '/lots', onCustomAction: this.onCustomAction },
      { title: 'Set new tenancy', url: '' }
    ];

    const { emailCheckType, dateError, errorPhoneNumber, errorDaytimePhoneNumber } = this.state;

    const disabled = !emailCheckType || dateError || !this.state.moveInDate || errorPhoneNumber || errorDaytimePhoneNumber;

    return (
      <div className='lot-info-content' style={{ paddingLeft: 29 }}>
        <div className='row'>
          <div className='form-group col-sm-8' style={{ marginBottom: 0 }}>
            <label className='col-sm-12' style={{ paddingLeft: 6, fontWeight: 500, fontSize: 15 }}>Set new tenancy</label>
          </div>
        </div>
        <div className='row'>
          <div className='form-group col-sm-8' style={{ marginBottom: 0 }}>
            <div className='col-sm-12' style={{ paddingLeft: 6 }}>
              <Breadcrumb breadcrumbs={breadcrumbs} />
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='form-group col-sm-8' style={{ marginBottom: 20 }}>
            <span className='col-sm-12' style={{ paddingLeft: 6, color: '#9B9B9B', marginBottom: 10 }}>New move in date</span>
            <label className='col-sm-12' style={{ paddingLeft: 6 }}>Move in date <span className='text-danger'>*</span></label>
            <div className='col-sm-6' style={{ paddingLeft: 6 }}>
              <Datetime
                ref={ref => { this.moveInDate = ref; }}
                name='moveInDate'
                inputProps={{ placeholder: 'mm/dd/yyyy' }}
                timeFormat={false}
                defaultValue={Moment(this.state.moveInDate)}
                onChange={(moveInDate) => {
                  if (Moment(moveInDate, 'MM/DD/YYYY', true).isValid() && moveInDate !== '') {
                    this.setState({ moveInDate, dateError: null });
                  } else {
                    this.setState({ dateError: 'Invalid datetime.' });
                  }
                }} 
                closeOnSelect={true}/>
              {this.state.dateError &&
                <span className='text-danger' style={{ fontSize: 12, marginTop: 5 }}>{this.state.dateError}</span>
              }
            </div>
          </div>
        </div>
        {this.state.emailCheckType === null &&
          <div>
            <div className='row'>
              <div className='form-group col-sm-8'>
                <span className='col-sm-12' style={{ paddingLeft: 6, color: '#9B9B9B', marginBottom: 10 }}>New tenant</span>
                <label className='col-sm-12' style={{ paddingLeft: 6 }}>Email address <span className='text-danger'>*</span>
                  <OverlayTrigger placement='top' overlay={this.toolTip()}>
                    <i className='fa fa-question-circle' style={{ marginLeft: 10 }} />
                  </OverlayTrigger>
                </label>
                <div className='col-sm-6 email-block' style={{ paddingLeft: 6 }}>
                  <input
                    type='text'
                    name='email'
                    ref='email'
                    className='form-control'
                    maxLength='256'
                    value={this.state.email}
                    onChange={this.onChangeEmail}
                    onKeyPress={this.onEnter.bind(this)} />
                  <i
                    className={'fa fa-check email-block-check-btn ' + (!this.onValidateEmail(this.state.email) ? 'disabled' : '')}
                    onClick={this.onCheckEmail} />
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='form-group col-sm-8'>
                <div className='col-sm-12' style={{ paddingLeft: 6, marginTop: 20 }}>
                  <span
                    className='btn btn-primary btn-siteone-default' onClick={this.onCustomAction}>Cancel</span>
                  <button className='btn btn-primary btn-info btn-siteone' onClick={this.onSubmit} disabled={disabled}>Save</button>
                </div>
              </div>
            </div>
          </div>
        }
        {this.state.emailCheckType === 3 &&
          <Form className='form-horizontal' ref={ref => { this.form = ref; }} onSubmit={this.onSubmit} style={{ paddingLeft: 15 }}>
            <div className='row'>
              <div className='form-group col-sm-8'>
                <span className='col-sm-12' style={{ paddingLeft: 6, color: '#ccc', marginBottom: 10 }}>New tenant</span>
                <label className='col-sm-12' style={{ paddingLeft: 6 }}>Email address <span className='text-danger'>*</span>
                  <OverlayTrigger placement='top' overlay={this.toolTip()}>
                    <i className='fa fa-question-circle' style={{ marginLeft: 10 }} />
                  </OverlayTrigger>
                </label>
                <div className='col-sm-6' style={{ paddingLeft: 6 }}>
                  <span>{this.state.userData.email}</span>
                  <i className='fa fa-pencil email-block-edit-btn' onClick={this.onClickToEditEmail} />
                </div>
              </div>

              <div className='row' style={{ margin: 0 }}>
                <div className='form-group col-sm-6' style={{ paddingLeft: 15 }}>
                  <div className='col-sm-10' style={{ paddingLeft: 0 }}>
                    <label className='col-sm-12' style={{ paddingLeft: 6, fontWeight: 'normal' }}>First name <span className='text-danger'>*</span></label>
                    <Input
                      type='text'
                      name='firstName'
                      ref='firstName'
                      className='form-control'
                      max='40'
                      maxLength='40'
                      validations={[Vali.required, Vali.maxlength]}
                      divStyle={{ paddingLeft: 6 }} />
                  </div>
                </div>
                <div className='form-group col-sm-6' style={{ paddingLeft: 15 }}>
                  <div className='col-sm-10' style={{ paddingLeft: 0 }}>
                    <label className='col-sm-12' style={{ paddingLeft: 6, fontWeight: 'normal' }}>Last name <span className='text-danger'>*</span></label>
                    <Input
                      type='text'
                      name='lastName'
                      ref='lastName'
                      className='form-control'
                      max='40'
                      maxLength='40'
                      validations={[Vali.required, Vali.maxlength]}
                      divStyle={{ paddingLeft: 6 }} />
                  </div>
                </div>
              </div>
              <div className='row' style={{ margin: 0 }}>
                <div className='form-group col-sm-6' style={{ paddingLeft: 15 }}>
                  <div className='col-sm-10' style={{ paddingLeft: 0 }}>
                    <label className='col-sm-12' style={{ paddingLeft: 6, fontWeight: 'normal' }}>Phone number</label>
                    <PhoneNumberInput
                      ref={ref => { this.phoneNumber = ref; }}
                      onError={this.onErrorPhoneNumber}
                      divStyle={{paddingLeft: 6}} />
                  </div>
                </div>
                <div className='form-group col-sm-6' style={{ paddingLeft: 15, paddingRight: 6 }}>
                  <div className='col-sm-10' style={{ paddingLeft: 0 }}>
                    <label className='col-sm-12' style={{ paddingLeft: 6, fontWeight: 'normal' }}>Daytime phone number</label>
                    <PhoneNumberInput
                      ref={ref => { this.daytimePhoneNumber = ref; }}
                      onError={this.onErrorDaytimePhoneNumber}
                      divStyle={{paddingLeft: 6}} />
                  </div>
                </div>
              </div>

              <div className='row'>
                <div className='form-group col-sm-8'>
                  <div className='col-sm-12' style={{ paddingLeft: 20, marginTop: 20 }}>
                    <span
                      className='btn btn-primary btn-siteone-default' onClick={this.onCustomAction}>Cancel</span>
                    <Submit className='btn btn-primary btn-info btn-siteone' disabled={disabled}>Save</Submit>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        }
        {(this.state.emailCheckType === 2 || this.state.emailCheckType === 1) && this.state.userData &&
          <div>
            <div className='row'>
              <div className='form-group col-sm-8'>
                <span className='col-sm-12' style={{ paddingLeft: 6, color: '#ccc', marginBottom: 10 }}>New tenant</span>
                <label className='col-sm-12' style={{ paddingLeft: 6 }}>Email address <span className='text-danger'>*</span>
                  <OverlayTrigger placement='top' overlay={this.toolTip()}>
                    <i className='fa fa-question-circle' style={{ marginLeft: 10 }} />
                  </OverlayTrigger>
                </label>
                <div className='col-sm-6' style={{ paddingLeft: 6 }}>
                  <span>{this.state.userData.email}</span>
                  <i className='fa fa-pencil email-block-edit-btn' onClick={this.onClickToEditEmail} />
                </div>
              </div>

              <div className='form-group col-sm-8'>
                {this.state.emailCheckType === 2 &&
                  <p className='col-sm-12' style={{ fontSize: 14, paddingLeft: 6 }}>
                    The email address <strong>{this.state.userData.email}</strong> already has an account on SiteOne Services:
                  </p>
                }
                {this.state.emailCheckType === 1 &&
                  <p className='col-sm-12' style={{ fontSize: 14, paddingLeft: 6 }}>
                    The email address <strong>{this.state.userData.email}</strong> is already associated with this <Translate translateKey='homeowner' /> account.
                  </p>
                }
              </div>
              <div className='form-group col-sm-8'>
                <div className='block-existing-user'>
                  <Avatar src={null} size={80} />
                  <h4 className='cls-bold'>{this.state.userData.displayName}</h4>
                  <h5>{this.state.userData.email}</h5>
                  <h5>
                    <span style={{ color: '#ccc' }}>Phone number</span>
                    <span style={{ fontSize: 16, fontWeight: 600, marginLeft: 15 }}>{this.state.userData.phoneNumber}</span>
                  </h5>
                </div>
              
              </div>
            </div>

            <div className='row'>
              <div className='form-group col-sm-8'>
                <div className='col-sm-12' style={{ paddingLeft: 6, marginTop: 20 }}>
                  <span
                    className='btn btn-primary btn-siteone-default' onClick={this.onCustomAction}>Cancel</span>
                  <button className='btn btn-primary btn-info btn-siteone' onClick={this.onSubmit} disabled={disabled}>Save</button>
                </div>
              </div>
            </div>
          </div>
        }
        {(this.state.emailCheckType === 0 || this.state.emailCheckType === 4) && this.state.userData &&
          <div>
            <div className='row'>
              <div className='form-group col-sm-8'>
                <span className='col-sm-12' style={{ paddingLeft: 6, color: '#ccc', marginBottom: 10 }}>New tenant</span>
                <label className='col-sm-12' style={{ paddingLeft: 6 }}>Email address <span className='text-danger'>*</span>
                  <OverlayTrigger placement='top' overlay={this.toolTip()}>
                    <i className='fa fa-question-circle' style={{ marginLeft: 10 }} />
                  </OverlayTrigger>
                </label>
                <div className='col-sm-6' style={{ paddingLeft: 6 }}>
                  <span>{this.state.userData.email}</span>
                  <i className='fa fa-pencil email-block-edit-btn' onClick={this.onClickToEditEmail} />
                </div>
              </div>

              <div className='form-group col-sm-8'>
                <p className='col-sm-12' style={{ fontSize: 14, paddingLeft: 6 }}>
                  The email address <strong>{this.state.userData.email}</strong> is this <Translate translateKey='lot' plurals />'s current {this.state.emailCheckType === 0 ? 'owner' : 'tenant'}.
                </p>
              </div>
              <div className='form-group col-sm-8'>
                <div className='block-existing-user'>
                  <Avatar src={null} size={80} />
                  <h4 className='cls-bold'>{this.state.userData.displayName}</h4>
                  <h5>{this.state.userData.email}</h5>
                  <h5>
                    <span style={{ color: '#ccc' }}>Phone number</span>
                    <span style={{ fontSize: 16, fontWeight: 600, marginLeft: 15 }}>{this.state.userData.phoneNumber}</span>
                  </h5>
                </div>
              </div>
            </div>

            <div className='row'>
              <div className='form-group col-sm-8'>
                <div className='col-sm-12' style={{ paddingLeft: 6, marginTop: 20 }}>
                  <span
                    className='btn btn-primary btn-siteone-default' onClick={this.onCustomAction}>Cancel</span>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    LotProfile: state.LotStore.LotProfile
  };
};

export default connect(mapStateToProps)(SetNewTenancy);



// WEBPACK FOOTER //
// ./src/Lots/Containers/lot-view-ownership-info-set-new-tenancy.js